import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import ro from './locales/ro.json'
import en from './locales/en.json'
import zh from './locales/zh.json'

export const SUPPORTED_LOCALES = [
    { code: 'ro', name: 'Română', flag: '🇷🇴' },
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'zh', name: '中文', flag: '🇨🇳' },
]

export const DEFAULT_LOCALE = 'ro'

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: { ro: { translation: ro }, en: { translation: en }, zh: { translation: zh } },
        fallbackLng: DEFAULT_LOCALE,
        supportedLngs: ['ro', 'en', 'zh'],
        interpolation: { escapeValue: false },
        // Fix: switching language used to require a manual page refresh.
        // useSuspense:false + bindI18n makes every useTranslation consumer
        // re-render immediately on changeLanguage (resources are bundled).
        react: { useSuspense: false, bindI18n: 'languageChanged loaded' },
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
            lookupLocalStorage: 'kanbify-locale',
        },
    })

i18n.on('languageChanged', (code) => {
    document.documentElement.setAttribute('lang', code)
})

document.documentElement.setAttribute('lang', i18n.resolvedLanguage || i18n.language || DEFAULT_LOCALE)

export function changeLocale(code) {
    if (!['ro', 'en', 'zh'].includes(code)) return
    i18n.changeLanguage(code)
    try { localStorage.setItem('kanbify-locale', code) } catch { /* localStorage unavailable (private mode) */ }
    document.documentElement.setAttribute('lang', code)
}

export default i18n
